import { CurrentOrderType } from "../controller/StoreController";
import { ChatType } from "../recoil/chat";

export const getCurrentLocation = (): Promise<{
  latitude: number;
  longitude: number;
}> => {
  return new Promise((resolve, reject) => {
    if ("geolocation" in navigator) {
      /*
        navigator.geolocation.getCurrentPosition(
          (position) => {
            resolve({
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            });
          },
          (error) => {
            reject(error);
          }
        );
        */
      var ua = navigator.userAgent.toLowerCase(),
        isAndroid = ua.indexOf("android") > -1,
        geoTimeout = isAndroid ? 15000 : 5000;

      navigator.geolocation.getCurrentPosition(
        (position: any) => {
          resolve({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
        },
        (error: any) => {
          reject(error);
          //   toast.error("현재 위치를 받기 위해 위치 권한을 허용해주세요.");
        },
        { enableHighAccuracy: true, maximumAge: 3000, timeout: geoTimeout }
      );
    } else {
      //   toast.error("브라우저에서 위치 정보를 지원하지 않아요.");
      reject(new Error("Geolocation API를 지원하지 않는 브라우저입니다."));
    }
  });
};

export const calculateDistance = (
  lat1: number,
  lng1: number,
  lat2: number,
  lng2: number
) => {
  const R = 6371;
  const dLat = (lat2 - lat1) * (Math.PI / 180);
  const dLon = (lng2 - lng1) * (Math.PI / 180);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * (Math.PI / 180)) *
      Math.cos(lat2 * (Math.PI / 180)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c;
  return distance;
};

export const padZero = (num: number) => {
  return (num < 10 ? "0" : "") + num;
};

export const getAngleComment = (angle: number) => {
  if (angle < 22.5 || angle > 337.5) return "N";
  else if (angle >= 22.5 && angle < 67.5) return "NE";
  else if (angle >= 67.5 && angle < 112.5) return "E";
  else if (angle >= 112.5 && angle < 157.5) return "SE";
  else if (angle >= 157.5 && angle < 202.5) return "S";
  else if (angle >= 202.5 && angle < 247.5) return "SW";
  else if (angle >= 247.5 && angle < 292.5) return "W";
  else if (angle >= 292.5 && angle < 337.5) return "NW";
};

export const extractNumber = (value: string) => {
  const matches = value.match(/\d+/g);
  return matches ? parseInt(matches[0]) : null;
};

export const searchSimilarData = (chat: ChatType, chatData: any) => {
  if (chat !== null && chatData !== null) {
    const findingIndex = extractNumber(chat.content);

    console.log("searchSimilarData", findingIndex, chatData);

    if (findingIndex !== null) {
      if (
        chatData.store_list &&
        findingIndex > 0 &&
        findingIndex < chatData.store_list.length
      ) {
        return chatData.store_list[findingIndex - 1];
      } else if (
        chatData.menu_list &&
        findingIndex > 0 &&
        findingIndex < chatData.menu_list.length
      ) {
        return chatData.menu_list[findingIndex - 1];
      } else if (
        chatData.ordered &&
        findingIndex > 0 &&
        findingIndex < chatData.ordered.length
      ) {
        return chatData.ordered[findingIndex - 1];
      } else {
        return null;
      }
    }
    const indexList: number[] = [];
    if (chatData.store_list) {
      chatData.store_list.map((item: any) => {
        let count = 0;
        for (let i = 0; i <= item.store_name.length; i++) {
          for (let j = 0; j <= chat.content.length; j++) {
            if (item.store_name[i] === chat.content[j]) count++;
          }
        }
        indexList.push(count);
      });
      return chatData.store_list[indexList.indexOf(Math.max(...indexList))];
    } else if (chatData.menu_list) {
      chatData.menu_list.map((item: any) => {
        let count = 0;
        const itemString =
          (item.store_name ? item.store_name : "") + item.prd_name;

        for (let i = 0; i <= itemString.length; i++) {
          for (let j = 0; j <= chat.content.length; j++) {
            if (itemString[i] === chat.content[j]) count++;
          }
        }
        indexList.push(count);
      });
      return chatData.menu_list[indexList.indexOf(Math.max(...indexList))];
    } else if (chatData.ordered) {
      chatData.ordered.map((item: CurrentOrderType) => {
        let count = 0;
        const itemString = item.oStoreData.store_name + item.sOrderName;
        for (let i = 0; i <= itemString.length; i++) {
          for (let j = 0; j <= chat.content.length; j++) {
            if (itemString[i] === chat.content[j]) count++;
          }
        }
        indexList.push(count);
      });
      return chatData.ordered[indexList.indexOf(Math.max(...indexList))];
    }
  }
};

/*
export const takeScreenshot = () => {
  const screenshotTarget = document.body;

  html2canvas(screenshotTarget).then((canvas) => {
    const base64image = canvas.toDataURL("image/png");
    window.location.href = base64image;
  });
}
*/
